<template>
  <div class="lecturer-wtxh-m scroll-box" @scroll="scrollBox($event)">
    <TopBarWtxh />
    <!-- 讲师网格 -->
    <div class="grid-wrap">
      <ul class="teacher-grid" v-if="resultsList.length">
        <li
          class="teacher-card"
          v-for="item in resultsList"
          :key="item.id"
          @click="goHomePage(item)"
        >
          <div class="card-avatar">
            <img v-if="item.avatar" :src="item.avatar" />
            <img v-else src="@/assets/per_img.png" />
          </div>
          <div class="card-name">
            <span>{{ item.name }}</span>
          </div>
        </li>
      </ul>
      <div class="nodata" v-if="loaded && resultsList.length == 0">
        <img class="nodata-img" :src="require('@/assets/no-data.png')" />
        <p class="nodata-text">当前搜索无结果</p>
      </div>
    </div>
    <BottomWtxhM />
  </div>
</template>

<script>
import TopBarWtxh from "@/m/common/topBarWtxh.vue";
import BottomWtxhM from "@/m/common/bottomWtxhM.vue";

export default {
  name: "LecturerWtxhM",
  components: {
    TopBarWtxh,
    BottomWtxhM,
  },
  data() {
    return {
      more: false,
      resultsList: [],
      nowPage: 1,
      limit: 10,
      loaded: false,
    };
  },
  mounted() {
    this.getResultsList();
  },
  methods: {
    getResultsList(fanye) {
      if (!fanye) {
        this.nowPage = 1;
        this.resultsList = [];
      }
      this.$axios
        .post(`/v1/teacher/list`, {
          page: this.nowPage,
          pre_page: this.limit,
        })
        .then((res) => {
          this.resultsList = [...this.resultsList, ...res.data.data];
          this.more = res.data.total > this.resultsList.length;
          this.loaded = true;
        });
    },
    scrollBox(e) {
      if (
        e.target.scrollHeight - e.target.clientHeight <= e.target.scrollTop + 2 &&
        this.more
      ) {
        this.nowPage++;
        this.getResultsList("fanye");
      }
    },
    goHomePage(item) {
      this.$router.push("/lecturerHomepage/" + item.id);
    },
  },
  watch: {
    $route() {
      location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
.lecturer-wtxh-m {
  background-color: rgba(247, 251, 252, 1);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.grid-wrap {
  padding: 40px 32px;
  flex: 1;
}
.teacher-grid {
  display: flex;
  flex-wrap: wrap;
  column-gap: 26px;
  row-gap: 26px;
}
.teacher-card {
  width: 330px;
  overflow: hidden;
  cursor: pointer;
}
.card-avatar {
  width: 330px;
  height: 354px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.card-name {
  box-shadow: 0px 8px 14px 0px rgba(234, 234, 234, 0.6);
  background-color: rgba(255, 255, 255, 1);
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 26px;
    font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
    color: rgba(62, 62, 62, 1);
    line-height: 36px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 280px;
  }
}
.nodata {
  width: 574px;
  padding-top: 20px;
  margin: 0 auto;
  text-align: center;
  .nodata-img {
    width: 100%;
    height: auto;
  }
  .nodata-text {
    font-size: 26px;
    color: #999;
    padding-top: 40px;
  }
}
</style>
